import { PacketOut } from "./PacketOut.js";
import { OutboundPacketType } from "./OutboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";


export class PacketOutRoll extends PacketOut {
    constructor() {
        super(OutboundPacketType.ROLL);
    }

    override writeContents(_context: MessageIOContext): Record<string, any> {
        return {};
    }
}
